import React, { Component } from "react";
import Table from 'antd/lib/table';
import httpRequest from "apis/httpRequest";
import { MY_GRADE_URL } from "actions/types"
const columns = [
	{
		title: '学年',
		dataIndex: 'XQ',
	},
	{
		title: '课程号',
		dataIndex: 'KCH',
	},
	{
		title: '课程名称',
		dataIndex: 'KCMC',
	},
	{
		title: '课程成绩',
		dataIndex: 'KCCJ',
	},
	{
		title: "绩点",
		dataIndex: 'JD',
	},
	{
		title: '是否及格',
		dataIndex: 'status',
	},
];

class PersonalGrade extends Component {
	state = {
		gradeData: [],
	}
	componentDidMount() {
		httpRequest.get(MY_GRADE_URL).then(res => {
			if (res.data.grade) {
				let gradeData = res.data.grade.datas
				for (var i = 0; i < gradeData.length; i++) {
					gradeData[i].status = '不及格'
					if (gradeData[i].KCCJ >= 60) {
						gradeData[i].status = '及格'
					}
				}
				this.setState({ gradeData: gradeData })
			}
		})
	}
	render() {
		const { gradeData } = this.state;
		return (
			<div className="personal-grade">
				<div className="personal-grade-content">
					<div className="title">成绩查询</div>
					<div className="table">
						<Table columns={columns} dataSource={gradeData} bordered={true} pagination={{
							// total: 20,
							// onChange: (page) => { console.log(page) },
							style: {
								float: "left"
							},
							className: "gafa-pagination"
						}} />
					</div>
				</div>
			</div>
		)
	}
}

export default PersonalGrade